                import React from 'react';
/*
import {
  cr,
  ls,
  hf,
  useGblz,
} from 'lib';
*/
import * as cr from './_cr';
import * as ls from "./_csLcl"; // local state

import * as icvLgnK10To1 from './icvLgnK10To1';
import * as icvLgnK10To2 from './icvLgnK10To2';

export const N = (pz: {
}) => {

  const _sPz = ls.usePagez({
    steps: [0],
  });

  //hf.l(`icvLgnK10Rz 17: here`);
  return ([

    _sPz.crt.steps[0] == 0 ?
    cr.c(icvLgnK10To1.N, {
      key: -10,
      sPz: _sPz,
    })
    : null,

    _sPz.crt.steps[0] == 1 ?
    cr.c(icvLgnK10To2.N, {
      key: -20,
      sPz: _sPz,
    })
    : null,

  ]);
};
